export default "__VITE_ASSET__Dv9Gf1mN__"